/** Special fix or lifehack for SonarQube pass tests, which disallow negative conditions */
export const not = (v: unknown): boolean => !v;

export const notEqual = (v1: unknown, v2: unknown): boolean => v1 !== v2;
